import React, { useState, useContext } from 'react'
import { VenueContext } from '../../../stores/VenueProvider'
import Box from '../../../components/Modal/Box'
import * as API from '../../../api/api.js'
import { t } from '../../../i18n'
import './CustomerBook.css'

const Field = ({ label, id, type, placeholder, required, autoComplete, value, onChange }) => (
    <div className="formRow">
        <label htmlFor={id} className="formRowLabel">{label}</label>
        <input
            className="formRowInput"
            id={id}
            type={type}
            placeholder={placeholder}
            required={required}
            autoComplete={autoComplete}
            value={value}
            onChange={onChange} />
    </div>
)

const OptinToggle = ({ title, onChange }) => (
    <div className="guestbook-toggle">
        <label className="guestbook-switch">
            <input type="checkbox" onChange={onChange} />
            <span className="guestbook-slider round"></span>
        </label>
        <div className="guestbook-slider-title">{title}</div>
    </div>
)

const NumberField = ({ label, id, placeholder, required, autoComplete, value, onChange }) => (
    <div className="formRow">
        <label htmlFor={id} className="formRowLabel">{label}</label>
        <input
            className="formRowInput"
            id={id}
            type="number"
            placeholder={placeholder}
            required={required}
            autoComplete={autoComplete}
            value={value}
            onChange={onChange}
            inputMode="numeric"
            pattern="[0-9]*" />
    </div>
)

const Multiline = ({ text }) => (
    <>
        {String(text || '').split('\n').map((line, index, lines) => (
            <React.Fragment key={index}>
                {line}
                {index < lines.length - 1 ? <br /> : null}
            </React.Fragment>
        ))}
    </>
)

export default (props) => {

    const { isVisible = false, onClose = () => { } } = props
    const venueStore = useContext(VenueContext)
    const expiringStorage = require('../../../helpers/expiringStorage')

    const [customerDetails, setCustomerDetails] = useState({
        lastname: '',
        firstname: '',
        phone: '',
        email: '',
        optin: false
    })
    const [detailsComplete, setDetailsComplete] = useState(false)
    const [processing, setProcessing] = useState(false)

    const handleSubmit = event => {
        event.preventDefault()

        if (detailsComplete) {
            setProcessing(true)
        } else {
            return
        }


        API.addGuestEntry(venueStore.venue.id, customerDetails.lastname, customerDetails.firstname, customerDetails.email, customerDetails.phone, customerDetails.optin)
            .then(response => {
                setProcessing(false)
                // set expiry to 6 hours
                expiringStorage.set('welcome', true, 21600000)
                onClose()
            })
            .catch(error => {

            })
    }

    return (
        <Box isVisible={isVisible} width="90%" height="80%" effect="fadeInUpBox" onClickAway={onClose}>
            <div className="book">
                <div className="closeBook" onClick={onClose}>X</div>
                <div className="header">
                    <center><b>{t('Guestbook.title')}</b></center><br /><br />
                    {t('Guestbook.intro')}<br /><br />
                    {t('Guestbook.pleaseFill')}<br />
                </div>
                <form className="form" onSubmit={handleSubmit}>
                    <Field
                        label={t('Guestbook.lastname')}
                        id="lastname"
                        type="text"
                        placeholder={t('Guestbook.lastname')}
                        required
                        autoComplete="name"
                        value={customerDetails.lastname}
                        onChange={(e) => {
                            setCustomerDetails({ ...customerDetails, lastname: e.target.value })
                            setDetailsComplete(customerDetails.lastname.length && customerDetails.firstname.length && (customerDetails.email.length || customerDetails.phone.length))
                        }} />
                    <Field
                        label={t('Guestbook.firstname')}
                        id="firstname"
                        type="text"
                        placeholder={t('Guestbook.firstname')}
                        required
                        autoComplete="name"
                        value={customerDetails.firstname}
                        onChange={(e) => {
                            setCustomerDetails({ ...customerDetails, firstname: e.target.value })
                            setDetailsComplete(customerDetails.lastname.length && customerDetails.firstname.length && (customerDetails.email.length || customerDetails.phone.length))
                        }} />
                    <NumberField
                        label={t('Guestbook.phone')}
                        id="phone"
                        type="number"
                        placeholder={t('Guestbook.phone')}
                        required
                        autoComplete="email"
                        value={customerDetails.phone}
                        onChange={(e) => {
                            setCustomerDetails({ ...customerDetails, phone: e.target.value })
                            setDetailsComplete(customerDetails.lastname.length && customerDetails.firstname.length && (customerDetails.email.length || customerDetails.phone.length))
                        }} />
                    <Field
                        label={t('Guestbook.email')}
                        id="email"
                        type="email"
                        placeholder={t('Guestbook.email')}
                        required
                        autoComplete="email"
                        value={customerDetails.email}
                        onChange={(e) => {
                            setCustomerDetails({ ...customerDetails, email: e.target.value })
                            setDetailsComplete(customerDetails.lastname.length && customerDetails.firstname.length && (customerDetails.email.length || customerDetails.phone.length))
                        }} />
                    <OptinToggle title={t('Guestbook.optin')} onChange={e => setCustomerDetails({ ...customerDetails, optin: e.target.value })} />
                    <input className="guestbook-submit" type="submit" disabled={processing} value={processing ? t('Payment.processing') : t('Guestbook.submit')} />
                </form>
                <div className="footer">
                    <Multiline text={t('Guestbook.footer', { name: venueStore.venue.name, address: venueStore.venue.address })} />
                </div>
            </div>
        </Box>
    )
}
